import type { RemoteParticipant } from 'livekit-client';

type Participant = Pick<RemoteParticipant, 'trackPublications'>;

export type BandwidthAttachmentDiagnostic = {
  readonly cloudParticipants: Record<
    string,
    Record<
      string,
      { readonly hasTrack: boolean; readonly kind: string; readonly subscribed: boolean }
    >
  >;
  readonly cloudRoomState: string;
};

/** Builds a JSON-safe view of the LiveKit state needed to diagnose HIL attachment failures. */
export const bandwidthAttachmentDiagnostic = (
  roomState: unknown,
  participants: ReadonlyMap<string, Participant>
): BandwidthAttachmentDiagnostic => {
  const cloudParticipants: BandwidthAttachmentDiagnostic['cloudParticipants'] = {};

  for (const [identity, participant] of participants) {
    const publications: BandwidthAttachmentDiagnostic['cloudParticipants'][string] = {};
    for (const [sid, publication] of participant.trackPublications) {
      publications[String(sid)] = {
        hasTrack: Boolean(publication.track),
        kind: String(publication.kind),
        subscribed: publication.isSubscribed
      };
    }
    cloudParticipants[String(identity)] = publications;
  }

  return {
    cloudParticipants,
    cloudRoomState: roomState === undefined ? 'no-cloud-room' : String(roomState)
  };
};
